export const IJR = 2022
export const AJR = 2023
export const NettobestaansmiddelenPartnerMax = 3490
export const HqMax = 11450

// brandstofprijzen 2022
export const Super_95_Ron = 1.9182;
export const Super_95_Ron_E10 = 1.8516;
export const Super_98_Ron = 2.0287;
export const Super_98_Ron_E10 = 1.9821;
export const Diesel_zwavelarm = 1.9895;
export const LPG= 0.8165;